import { BehaviorSubject, Observable } from "rxjs";
import { injectable } from "inversify";
import { LoadingEventType } from "../../enums/loadingEventType";
import { LoadingEvent } from "../../models/loadingEvent";
import { IMessagingService } from "../";
import { map } from "rxjs/operators";

@injectable()
class MessagingService implements IMessagingService {
    protected isLoading: BehaviorSubject<boolean>;
    protected loadingEvents: BehaviorSubject<LoadingEvent[]>;

    constructor() {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.loadingEvents = new BehaviorSubject([]);
    }

    // notify subscribers that the loading state has changed
    OnLoading(): Observable<boolean> {
        return this.loadingEvents.pipe(
            map((events) => {
                return (
                    events.filter((event) => {
                        return event.type === LoadingEventType.Page;
                    }).length > 0
                );
            })
        );
    }

    // notify the store that a loading event has started
    StartLoadingEvent(id: string, type: LoadingEventType) {
        const events = this.loadingEvents.value.concat(new LoadingEvent(id, type));
        this.loadingEvents.next(events);
    }

    // notify the store that a loading event has ended
    EndLoadingEvent(id: string) {
        const events = this.loadingEvents.value.filter(loadingEvent => loadingEvent.id != id);
        this.loadingEvents.next(events);
    }
}

export { MessagingService };
